import i18next from 'i18next';
import yoflagsjs from '@yola/yoflagsjs';
import yousersjs from '@yola/yousersjs';
import {
  serviceProvider,
  accessors as subscriptionManagerAccessors,
  constants as subscriptionManagerConstants,
} from '@yola/subscription-manager-js';
import template from './template';
import { CUSTOMERS_AMOUNT } from './constants/common';
import User from '../../modules/user';
import Configuration from '../../modules/configuration';
import parseElementFromString from '../../utils/parse-element-from-string';
import redirectToUrl from '../../utils/redirect-to-url';
import prepareFadeIn from '../../utils/fade-in';

const { B2C_HOSTING_GOLD } = subscriptionManagerConstants.SubscriptionType;

const DIFM_BANNER_FEATURE = 'nn_difm_promo';

async function isDifmEnabled(isUserAuthenticated, apiUrl) {
  let isFeatureEnabled = false;

  try {
    const { visitorFlags, userFlags } = await yoflagsjs.initWith(apiUrl);

    if (isUserAuthenticated) {
      // as we use http protocol to run yolacom localy this request
      // does not work localy because of Yola cookie Secure
      const {
        data: {
          data: { [DIFM_BANNER_FEATURE]: featureFlag },
        },
      } = await userFlags(DIFM_BANNER_FEATURE);

      isFeatureEnabled = featureFlag || false;
    } else {
      const { data } = await visitorFlags();

      isFeatureEnabled = data[DIFM_BANNER_FEATURE] || false;
    }
  } catch (error) {
    console.error(error);
  }

  return isFeatureEnabled;
}

async function initialize() {
  const user = User.get();
  const config = Configuration.get();
  const apiUrl = config.getPublicApiUrl();
  const isUserAuthenticated = user.isAuthenticated();

  if (isUserAuthenticated) {
    try {
      await serviceProvider.fetchCurrentPackage();
      const currentPackageType = subscriptionManagerAccessors.getCurrentPackageType();
      const hasGoldSubscription = currentPackageType === B2C_HOSTING_GOLD;

      if (hasGoldSubscription) {
        return;
      }

      const userPreferences = await yousersjs.preferences().get();

      if (userPreferences?.body?.difm_order_submitted === 'True') {
        return;
      }
    } catch (error) {
      console.error(error);
    }
  }

  const showDifmPromoBanner = await isDifmEnabled(isUserAuthenticated, apiUrl);

  if (showDifmPromoBanner) {
    const data = {
      title: i18next.t('Limited-time offer'),
      description: i18next.t('Get a professional website built and managed for you with'),
      reviewText: i18next.t('Trusted by {customers}+ customers', { customers: CUSTOMERS_AMOUNT }),
      buttonText: isUserAuthenticated
        ? i18next.t('Upgrade to Gold')
        : i18next.t('Get started with Gold'),
    };

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.sitebuilderhostqa.net/css?family=Roboto:400,400i,500,500i,700,700i,900,900i&display=swap';
    const head = document.querySelector('head');
    head.appendChild(link);

    const myyolaUrl = config.getMyyolaUrl();
    const difmPromoBanner = parseElementFromString(template(data));
    const fadeIdAnimation = prepareFadeIn(difmPromoBanner);
    document.body.prepend(difmPromoBanner);
    difmPromoBanner.addEventListener('click', () => redirectToUrl(`${myyolaUrl}difm-upsell`));
    fadeIdAnimation.run();
  }
}

export default initialize;
